/**
 * Step action types
 */

const ASK_FOR_NEXT_STEP = 'ASK_FOR_NEXT_STEP';

export { ASK_FOR_NEXT_STEP };



// WEBPACK FOOTER //
// ./src/services/NavigationService/actionType.js